import { pageEntry } from "../../client/index.ts";
import { designCopy } from "../../design/copy.ts";
import { journalQuery } from "./query.ts";

const explored = { replaceOn: ["filtro", "objeto", "pessoa"], query: journalQuery };
export const entrypoints = [pageEntry("registro", designCopy.lugares.registro, () => import("./view.tsx"), explored)];
